import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import AddTransport from "./AddTransport";
import { Box, Paper, Stack, Typography } from "@mui/material";
import DatePickerCustom from "../../../../components/DatePicker/DatePickerCustom";
import dayjs from "dayjs";
import GlobalMultiSelect from "../../../../components/mui/GlobalMultiSelect";
import { useSelector } from "react-redux";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { transportaionTableHeader } from "../../../../components/datagrid/EmployeeService/Trasportaion/transportaionTableHeader";
import { useDispatch } from "react-redux";
import {
  getAllTransportaionList,
  getAllTransportTimeSlots,
  getPaymentStatus,
} from "../../../../redux/features/trasportationSlice";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SeatAvailability from "./SeatAvailability";
import useResponsive from "../../../../Hooks/useResponsive";

const TransportationView = () => {
  const dispatch = useDispatch();
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");

  useEffect(() => {
    dispatch(getPaymentStatus());
  }, []);
  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;
  const { resData, loading, AllTimeSlots } = useSelector(
    (store) => store.transportation
  );
  const { data, meta } = resData;
  const [selectedDate, setSelectedDate] = useState(() => {
    const now = dayjs();
    const hour = now.hour();
    // If the current time is between 7 PM (19:00) and midnight (00:00), use the next day.
    return hour >= 19
      ? now.add(1, "day").format("YYYY-MM-DD")
      : now.format("YYYY-MM-DD");
  });

  const [selectedSlots, setSelectedSlots] = useState([]); //SLOT FILTER VALUES PUSHED HERE
  const dispatchParams = {
    selectedDate,
    paginationData,
    selectedSlots,
  };

  useEffect(() => {
    dispatch(getAllTransportTimeSlots());
  }, []);

  useEffect(() => {
    if (pageNum) {
      //GETTING THE ALL BOOKED USERES DETAILS FOR THE SELECTED DATE
      dispatch(getAllTransportaionList(dispatchParams));
    }
  }, [gridSize, pageNum, search, selectedSlots, selectedDate]);

  return (
    <GlobalWrapper
      title={"Transportation"}
      actions={
        <Stack direction={direction} gap={1}>
          <SeatAvailability date={selectedDate} />
          <AddTransport dispatchParams={dispatchParams} />
        </Stack>
      }
    >
      <Box>
        <Box>
          <Stack direction={direction} gap={1} >
            <Box sx={{ flex: 0.5 }}>
              <DatePickerCustom
                fullWidth={true}
                value={dayjs(selectedDate)}
                setValue={(date) => setSelectedDate(date.format("YYYY-MM-DD"))}
                viewDetails={["year", "month", "day"]}
                error={false}
              />
            </Box>
            <Box>

            </Box>
            <Box sx={{ flex: 1 }}>
              <GlobalMultiSelect
                sx={{ minWidth: "100%" }}
                label={"Time Slots"}           
                arrayState={selectedSlots}
                arraySetState={setSelectedSlots}
                data={AllTimeSlots}
                keys={{ id: "slotId", value: "slotName" }}
              />
            </Box>     
          </Stack>
        </Box>

        <Box
          sx={{
            my: 1,
            display: "flex",
            justifyContent: mdDown ? "flex-start" : "flex-end",
          }}
        >
          <Paper elevation={1} sx={{ display: "flex", p: 1 }}>
            <PeopleAltIcon sx={{ color: "primary.main", mr: 1 }} />
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ fontWeight: "bold" }}
            >
              Booked Users Count : {meta?.totalRecords ?? 0}
            </Typography>
          </Paper>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Paper>
            <GlobalDatagrid
              tableHead={transportaionTableHeader}
              rows={data}
              meta={meta?.totalRecords}
              rowUniqueId="sl_no"
              loading={loading}
            />
          </Paper>
        </Box>
      </Box>
    </GlobalWrapper>
  );
};

export default TransportationView;
